import React from 'react';
import PropTypes from 'prop-types';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import { Input } from 'components/landing/components/input';
import { Button } from 'components/landing/components/button';
import { Description } from 'components/landing/components/description';
import { Content } from 'components/landing/components/content';

import { formSchema } from './config';

const dumbDemoForm = dumbBem('demo-form');
const ContactForm = tx([{ element: 'contact-form' }, dumbDemoForm])('div');
const ContactFormLine = tx([{ element: 'contact-form-line' }, dumbDemoForm])('div');

const Form = ({
  handleSubmit,
  requestBtnTitle,
  parentState,
  getErrorMsg,
  handleInputBlur,
  handleInputFocus,
  handleInputChange,
}) => {
  return (
    <ContactForm>
      <Description>Fill this out and our team will get in touch.</Description>

      {formSchema.map(item => (
        <ContactFormLine key={item.name} modifier={item.full ? 'full' : ''}>
          <Input
            name={item.name}
            onBlur={handleInputBlur}
            onFocus={handleInputFocus}
            onChange={handleInputChange}
            placeholder={item.label}
            value={parentState[item.name]}
            errorMsg={getErrorMsg(item.name)}
          />
        </ContactFormLine>
      ))}

      <Content modifier="signin">
        <Button
          onClick={handleSubmit}
          modifier="reversed-colors"
        >{requestBtnTitle}
        </Button>
      </Content>
    </ContactForm>
  );
};

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  requestBtnTitle: PropTypes.string.isRequired,
  parentState: PropTypes.object.isRequired,
  getErrorMsg: PropTypes.func.isRequired,
  handleInputBlur: PropTypes.func.isRequired,
  handleInputFocus: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
};

export default Form;



// WEBPACK FOOTER //
// ./src/components/landing/components/demoForm/Form.js